<template>
    <div>
      <pxkeji-rightHeader />
  
      <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="子站集合">
                <a-select
                        show-search
                        :filter-option="filterOption"
                        v-model="where.keyword.dataZone"
                        mode="multiple"
                        allowClear
                        @change="changeDataZone"   
                >
                    <a-select-option
                        :value="subinfo.id"
                        v-for="(subinfo, index) in where.subsites"
                        :key="index+'--'+subinfo.name"
                    >{{subinfo.name}}
                    </a-select-option>
                </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="用户信息">
              <a-input placeholder="请输入用户名/姓名/身份证号/手机号" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="充值方式">
              <a-select v-model="where.keyword.body" allowClear @change="chargeTypeChange" >
                <a-select-option v-for="(info, index) in where.chargeTypeOption" :key="index" :value="info.val">{{ info.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="充值时间">
              <a-range-picker
                format="YYYY-MM-DD"
                :placeholder="['开始时间', '结束时间']"
                @change="onTimeChange"
              />
            </a-form-item>
          </a-col>
          
        </a-row>
        <a-row  :gutter="24">
          
            <a-col :span="6">
                <a-form-item label="用户组" >
                    <a-select
                        :disabled="statusList.groupDisableStatus"
                        show-search
                        v-model="where.keyword.groupId"
                        :filter-option="filterOption"
                        allowClear
                        @change="groupChanged"
                    >
                        <a-select-option
                          :value="info.id"
                          v-for="(info, index) in where.grouplist"
                          :key="index"
                        >{{info.name}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col :span="6">
                <a-form-item label="所在地区">
                    <a-cascader
                            :options="where.areas"
                            placeholder="请选择所在地区"
                            change-on-select
                            @change="onAreachange"
                            :fieldNames="{ label: 'name', value: 'name', children: 'children' }"
                    />
                </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="单位名称">
                <a-input placeholder="请输入" v-model="where.keyword.company" />
              </a-form-item>
            </a-col>
            <a-col :span="2" :style="{ textAlign: 'left' }">
                <a-button type="primary" @click="searchList" style="margin-top: 5px;" >搜索</a-button>
            </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <a-button type="primary"  @click="exportData" style="margin-bottom: 10px;" v-btnlimit="'子站充值统计-导出'">导出数据</a-button>
      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="pageChange"
        :dataSource="list.datas"
        :loading="isloading"
        :locale="{emptyText:'请按需求筛选后，点击搜索'}"
      >
        <span slot="dataZoneName" slot-scope="dataZoneName">
          <span >{{ dataZoneName?dataZoneName:'总站数据' }}</span>
        </span>
        <span slot="sourceType" slot-scope="sourceType">
            <span v-if="sourceType==0">个人注册</span>
            <span v-else>系统导入</span>
          </span>
        <span slot="status" slot-scope="status">
          <a-tag v-if="status==0" color="red">禁用</a-tag>
          <a-tag v-else color="green">启用</a-tag>
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div> 
    </div>
  </div>
  </template>
  <script>
  var that;
  const columns = [
  {
    dataIndex: "dataZoneName",
    key: "dataZoneName",
    align: "center",
    title: "站点",
    scopedSlots: { customRender: "dataZoneName" }
  },
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "记录编号"
  },
  {
    dataIndex: "userName",
    key: "userName",
    align: "center",
    title: "姓名"
  },
   /* {
        dataIndex: "telephone",
        key: "telephone",
        align: "center",
        title: "手机号"
    },*/
  {
    dataIndex: "count",
    key: "count",
    align: "center",
    title: "充值金额"
  },
  {
    dataIndex: "body",
    key: "body",
    align: "center",
    title: "充值方式"
  },
  {
    dataIndex: "addTime",
    key: "addTime",
    align: "center",
    title: "充值时间"
  }
  ];
  
  export default {
    name: "userlist",
    data() {
      return {
        isloading:false,
        /** 列表显示模块 */
        list: {
          columns, //表头
          datas: [], //数据
          pagination: {
            showQuickJumper: true,
            hideOnSinglePage: true,
            total: 0,
            current: 1, //页码
            defaultPageSize: 10 //页容
          }
        },
        statusList:{
          groupDisableStatus:true,//用户组状态控制器
          adminStatus:true,//主管部门状态控制器
          exportButStatus:true //导出按钮状态控制器
        },
        /** 查询条件模块 */
        where: {
          //向后端传递的查询数据
          keyword: {
            name:"",//用户名称
            dataZone:[],//子站ID
            startTime: "",//充值开始时间
            endTime: "",//充值结束时间
            body: "",//充值方式
            company: "",//所属单位
            administration:"",//主管部门
            groupId:"",//用户组
            province:'',//省
            city:'',//市
            area:'',//区
            pageNow:1,//默认首页
            pageSize:10//默认查询长度
          },

          /*************以下页面展示的option数据***************/
          //站点集合
          subsListOption:[],
          //注册方式
          chargeTypeOption:[
            {name:"购物消费",val:"购物消费"},{name:"线下充值",val:"线下充值"}
          ],
          //用户主
          grouplist: [],
          //区域列表
          areas:[],
          //子站集合
          subsites:[],
        },

      };
    },
    components: {},
    mounted: function() {
      this.$nextTick(function() {
        this.where.areas=this.$api.city.city;
        that = this;
        this.getSubsites();
        //this.getPageList();
      });
    },
    watch: {
      selectRows: function() {
      }
    },
    methods: {
        /**按钮区 */
        searchList(){//点击搜索按钮
          this.list.pagination.current = 1;
          this.where.keyword.pageNow = 1;
            this.getPageList();
        },
        //过滤搜索结果 输入关键字出相应的搜索结果
        filterOption(input, option) {
          return (
              option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        /**初始化数据区域 */
        //初始化搜索用户信息
        getPageList(){
          this.isloading = true;
          var param = this.where.keyword
          this.$api.recharge
            .getChargeListByDataZone(param)
            .then(res => {
              this.isloading = false;
              if (res.errorCode == this.$msg.responseCode.success) {
                this.list.datas = res.data.records;
                this.list.pagination.total = res.data.total;
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
              this.error();
            });
        },
        //初始化用户主
        getgrouplist() {
          this.$api.usergroup
            .getGroupIdByDataZone({dataZone:this.where.keyword.dataZone[0]})
            .then(res => {
              if (res.errorCode == this.$msg.responseCode.success) {
                this.where.grouplist = res.data;
              } else {
                this.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.error();
            });
        },
        //获取子站集合
        getSubsites(){
            this.$api.area.getAllSubsitesList().then((res)=>{
              if (res.errorCode == this.$msg.responseCode.success) { 
                this.where.subsites = res.data
              }else{
                this.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.error();
            });
        },
        //导出用户数据
        exportData(){
          window.location.href = this.$api.recharge.exportChargeLogByDataZone(this.where.keyword);
        },
        /**选项区*/
        //日期选择 开始时间，结束时间
        onTimeChange(date, dateString) {
            this.where.keyword.startTime = dateString[0];
            this.where.keyword.endTime = dateString[1];
        },
        // 选择区域 省市县
        onAreachange(v){
          this.where.keyword.province =  v[0]?v[0]:"";
          this.where.keyword.city =  v[1]?v[1]:"";
          this.where.keyword.area =  v[2]?v[2]:"";
        },
        //赋值用户组
        groupChanged(v) {
          this.where.keyword.groupId= v?v:''
        },
        //清除动作
        chargeTypeChange(v){
          this.where.keyword.body= v?v:"";
        },
        //切换页码
        pageChange(v){
          this.list.pagination.current=v.current
          this.where.keyword.pageNow = v.current
          this.getPageList();
        },
        //子站选择项目变化
        changeDataZone(v,i){
          this.where.grouplist=[];
          this.where.keyword.groupId="";
          if(v && v.length == 1){
            this.getgrouplist();
            this.statusList.groupDisableStatus=false;
            this.statusList.adminStatus=false;
            this.statusList.exportButStatus=false;
          }else{
            this.statusList.groupDisableStatus=true;
            this.statusList.adminStatus=true;
            this.statusList.exportButStatus=true;
            //this.where.keyword.dataZone="";
          }
        },
    }
  };
  </script>
  
  <style>
  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }
  
  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }
  
  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }
  
  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #fafafa;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }
  
  .cang_sta {
    text-align: center;
  }
  
  .cang_sta img {
    width: 35px;
  }
  </style>
  
  